import React from 'react';
import TabProvider from 'context/restaurant/TabContext';
import CartProvider from 'context/restaurant/CartContext';
import CashierProvider from 'context/restaurant/CashierContext';
import WaiterFlow from './WaiterFlow';

export default function WaiterPage() {
    return (
        <CashierProvider>
            <TabProvider>
                <CartProvider>
                    <WaiterFlow />
                </CartProvider>
            </TabProvider>
        </CashierProvider>
    );
}
